import {Component, OnInit, ViewChild} from '@angular/core';
import {LocalStorageService} from 'ng2-webstorage';
import {MessageService} from 'primeng/components/common/messageservice';
import {ConfirmationService, Paginator} from 'primeng/primeng';
import {ParentChildService} from '../../../../../components/parentchild/parentchild.service';
import {DataAnalyticsService} from '../../../../../components/dataAnalytics/dataAnalytics.service';

@Component({
  selector: 'app-student-profile',
  templateUrl: './teacher-view.component.html',
  styleUrls: ['./teacher-view.component.css']
})

export class TeacherViewComponent implements OnInit {
  display = "none";
  display1 = "none";

  display2 = "none";
  display3 = "none";


  public SchoolYear: any;
  public Table: any;
  public ShowLevelData: any;
  public selectedlevel: any;
  public selectedYear: any;
  public selectedsec: any;
  public mappedData: any;
  public selectedgrade:  any;
  public selectedsection:  any
  public nameofsec:  any
  public sectionId:  any
  public sectionList:  any
  public subjectsList:  any
  public selectedSubject:  any

  public bigCurrentPage: number = 1;
  public selectedRows: number = 10;

  public SubjectsSemesterInfoData : any =[] ;
  public TeacherDetailsData : any = [];
  public TeacherId : any;
  public TeacherStdSectionData : any = [];
  public TeacherSectionData : any = [];
  public TeacherSubjectData : any = [];
  public SubTeacherId : any;
  public StandardId : any;
  public SectionId : any;
  public SubjectId : any;
  public ListOfSem : any = [];
  public SemArray : any = [];

  profilePictureUrlM: string = 'assets/images/teacher/maleteacherpropic.png';
  profilePictureUrlF: string = 'assets/images/teacher/femaleteacherpropic.png';



  constructor(private dataAnalyticsService: DataAnalyticsService, private localStorage: LocalStorageService) {
  }
  ngOnInit() {

    this.getAcademicYear();
  }

  /*------------------------getAcademicYear-----------------------*/
  private getAcademicYear() {
    this.dataAnalyticsService
      .getAcadamicYearOfyears()
      .finally(() => {})
      .subscribe(
        (response) => {
          this.SchoolYear = response["yearList"];
          console.log("SchoolYear", this.SchoolYear);
          this.SchoolYear.sort((a, b) => b.AcademicYear.localeCompare(a.AcademicYear));

          try {
            this.selectedYear = this.SchoolYear[0].YearId
            this.getLevelsName();
          } catch (error) {}
        },
        (error) => {
          this.SchoolYear = [];
          console.error(error);
        }
      );
  }
  changeYear(){
    console.log("selectedYear",this.selectedYear)

  }

  //------------------LEVEL Primary, secondary----------------------------------------------------------------


  private getLevelsName() {
    this.dataAnalyticsService
      .getLevel()
      ._finally(() => {})
      .subscribe((response) => {
        this.ShowLevelData = response;
        console.log("LevelData", this.ShowLevelData);
        try {
          this.selectedlevel =  this.ShowLevelData[0].Id;
          //this.getClassSection(this.selectedlevel["Id"]);
          this.getLevelClassSection(this.selectedlevel);
        } catch (error) {}
      });
  }

  getLevelsListById(){
    console.log("Levels", this.selectedlevel);
    this.getLevelClassSection(this.selectedlevel);
  }

  //------------------------Ex Grade 1,2,3, & A,B,C--------------------------------------------------------------

  private getLevelClassSection(lid) {
    this.dataAnalyticsService.GetLevelStandardSectionMapping(lid).finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        console.log("mappedData", mappedData);
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (true) {
          this.mappedData = mappedData;

        }

        try {
          this.selectedgrade = mappedData[mappedData.length - 1];
          this.getSectionByGrade(this.selectedgrade);
          this.selectedsection = this.selectedgrade.Sections[0];
        } catch (error) {
          //window.location.reload();
        }

        try {
          this.nameofsec = this.selectedsection.sectionName;
          this.sectionId = this.selectedsection.SectionId;
        } catch (error) {

        }


      },
      error => {
        this.mappedData = [];
        this.sectionList = [];
        this.subjectsList = [];
        this.selectedgrade = null;
        this.selectedsection = null;
        this.selectedSubject = null;
      });
  };

  getSectionByGrade(grade) {
    this.subjectsList = [];
    this.selectedSubject = null;
    this.sectionList = grade.Sections;
    // console.log(this.sectionList);
    try {
      this.selectedsection = this.sectionList[0];
      // console.log(this.selectedsection);
      this.selectedsec = this.selectedsection.SectionId;
      /***************/
      this.getTeacherDetails();
      /*************/
    } catch (error) {

    }
  }

  getGclClassesListById(section) {

    this.nameofsec = section.sectionName;
    this.sectionId = section.SectionId;
    //this.getStudentData(this.standardId,section.SectionId,this.yearId)
    this.selectedsec = section.SectionId;

    console.log('getGclClassesListById', this.selectedsec);
    this.getTeacherDetails();

  }
  //------------------------TABLE--------------------------------------------------------------
  searchString: any;
  selectedlevelname: any;


  private getTeacherDetails() {
    this.dataAnalyticsService
      .getTeacherDetailsForSection(this.selectedYear, this.selectedsec)
      .finally(() => {})
      .subscribe(
        (response) => {
          this.Table = response["Value"];
          console.log("Table", this.Table);
          try {

          } catch (error) {}
        },
        (error) => {
          this.Table = [];
          console.error(error);
        }
      );
  }


  /***************************************************************************************************************************** */
  AddLevel() {
    this.display = "block";
  }

  ViewTeacher() {
    this.display1 = "block";
  }

  ViewTeacher1() {
    this.display2 = "block";
  }

  ViewTeacher2() {
    this.display3 = "block";
  }

  UpdateTeacher() {
    this.display = "block";
  }

  onCloseHandled() {
    this.display = "none";
    this.display1 = "none";

    this.display2 = "none";
    this.display3 = "none";
  }


  DeleteTeacher() {

  }

  updateLeveladdSchool() {

  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/teacher-details/teacher-view/teacher-view.component.ts